/* eslint-disable @typescript-eslint/ban-types */
import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../icon';
import { Sidebar } from '../sidebar';
import { makeDropdownComponent, makeDropdownBackdrop, makeDropdownToggle, makeDropdownCollapse, makeMenuContainer, makeMenuItems, makeMenuItem, makeMenuLink, makeMenuDivider, makeDropdownCloseButton, } from './mixins';
import { useWindowSize } from '../../hooks/window-size';
const DropdownComponent = styled.div `
  ${() => makeDropdownComponent()}
`;
const DropdownBackdrop = styled.div `
  ${(props) => makeDropdownBackdrop(props)}
`;
const DropdownToggle = styled.button `
  ${() => makeDropdownToggle()}
`;
const DropdownCollapse = styled.div `
  ${(props) => makeDropdownCollapse(props)}
`;
const MenuContainer = styled.div `
  ${(props) => makeMenuContainer(props)}
`;
const MenuItems = styled.div `
  ${(props) => makeMenuItems(props)}
`;
const MenuItem = styled.span `
  ${(props) => makeMenuItem(props)}
`;
const MenuLink = styled.a `
  ${(props) => makeMenuLink(props)}
`;
const MenuDivider = styled.div `
  ${(props) => makeMenuDivider(props)}
`;
const DropdownCloseButton = styled.button `
  ${() => makeDropdownCloseButton()}
`;
const ItemList = (props) => {
    const { dropdownHeader = null, items, dropdownKey, skin = 'new-skin', onClickHandler, dropdownFooter = null, maxHeight = 'auto' } = props;
    return (React.createElement(MenuContainer, { skin: skin },
        dropdownHeader && dropdownHeader,
        React.createElement(MenuItems, { maxHeight: maxHeight, skin: skin }, items.length > 0 &&
            items.map((item) => (React.createElement(MenuItem, { key: `${dropdownKey}-item-${item.key}`, skin: skin }, item.divider ? (React.createElement(MenuDivider, { skin: skin })) : (React.createElement(MenuLink, Object.assign({ href: item.href, id: item.id }, item.props, { onClick: (e) => (onClickHandler ? onClickHandler(e, item) : null), skin: skin }),
                item.before,
                item.content,
                item.after && item.after)))))),
        dropdownFooter && dropdownFooter));
};
const SidebarMenu = (props) => {
    const { show, closeType, toggleDropdownContent } = props;
    return (React.createElement(Sidebar, { closeType: closeType, visible: show, position: props.position, handleClose: toggleDropdownContent },
        React.createElement(ItemList, Object.assign({}, props))));
};
const DropdownMenu = (props) => {
    const { show, position = 'left', closeButton = true, closeDropdownContent, skin = 'new-skin', maxHeight = 'auto ' } = props;
    return (show && (React.createElement(DropdownCollapse, { position: position, skin: skin, maxHeight: maxHeight },
        closeButton && (React.createElement(DropdownCloseButton, { onClick: () => closeDropdownContent() },
            React.createElement(Icon, { name: "icon-light-close", color: "rgba(0, 0, 24, 0.84)", size: "24" }))),
        React.createElement(ItemList, Object.assign({}, props)))));
};
export const Dropdown = (props) => {
    const { visible = false, dropdownKey = 'dropdown', children, callback = () => null, maxHeight = 'auto' } = props;
    const { isMobile, isTabletPortrait } = useWindowSize();
    const [show, setShow] = useState(visible);
    const onClickHandler = (e, item) => {
        e.preventDefault();
        if (callback)
            callback(item);
        if (item && item.href)
            window.location.href = item.href;
    };
    const toggleDropdownContent = () => {
        setShow(!show);
    };
    const closeDropdownContent = () => {
        setShow(false);
    };
    return (React.createElement(DropdownComponent, Object.assign({}, props, { key: `${dropdownKey}-dropdown` }),
        React.createElement(DropdownToggle, { onClick: () => toggleDropdownContent() }, children),
        isMobile || isTabletPortrait ? (React.createElement(SidebarMenu, Object.assign({}, props, { withArrow: false, closeType: "close", show: show, toggleDropdownContent: toggleDropdownContent, onClickHandler: onClickHandler }))) : (React.createElement(DropdownMenu, Object.assign({}, props, { show: show, closeDropdownContent: closeDropdownContent, maxHeight: maxHeight }))),
        show && !isMobile && !isTabletPortrait && React.createElement(DropdownBackdrop, { onClick: () => closeDropdownContent() })));
};
